import { createReducer, on } from '@ngrx/store';
import { AirplaySecurityProfileApiActions } from './airplay-security-profile.actions';
import { initialState, adapter } from './airplay-security-profile.state';

export const airplaySecurityProfilesReducer = createReducer(
  initialState,
  on(AirplaySecurityProfileApiActions.profilesLoaded, (state, { profiles }) => adapter.upsertMany(profiles, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAirplaySecurityProfileIds = selectIds;
export const selectAirplaySecurityProfileEntities = selectEntities;
export const selectAllAirplaySecurityProfiles = selectAll;
